import { LineChart, Thermometer } from 'lucide-react';
import type { TopicDefinition } from '@/shared/surfaces/TopicCatalogTypes';

/**
 * Adoption views, a section of the Behavior surface. The composite Adoption
 * score screen (see `features/adoption`) is the section's Overview entry; the
 * topics below cover momentum and per-person adoption movement. The four ranked
 * "reach" lists were replaced by the score screen's groupable drivers grid.
 * Order here is the interior nav order of the Adoption rail section (after
 * Overview).
 */
export const ADOPTION_CATALOG: TopicDefinition[] = [
    {
        id: 'team-heatmap',
        title: 'Adoption Heatmap',
        navLabel: 'Adoption Heatmap',
        hook: 'Some teams are heating up week over week while others cool off.',
        question: 'Which teams are heating up week over week?',
        icon: Thermometer,
        accent: 'rose',
        vizKind: 'time-matrix',
        primaryField: 'user_department',
        drillField: 'user_id',
        drillLabel: 'person',
        headlineMetric: 'users',
        unitLabel: 'people',
        lensLabel: 'department',
        lensPlural: 'departments',
        timeBucket: 'week',
        matrixRowLimit: 8,
    },
    {
        id: 'adoption-trend',
        title: 'Active people over time',
        navLabel: 'Momentum',
        hook: 'The adoption curve is the truest signal of momentum.',
        question: 'How is the active-user count trending?',
        icon: LineChart,
        accent: 'violet',
        vizKind: 'trend',
        primaryField: 'user_department',
        headlineMetric: 'users',
        unitLabel: 'people',
        lensLabel: 'department',
        lensPlural: 'departments',
        timeBucket: 'week',
    },
];
